import httpRequest from '@/utils/request.js'

import i18n from '../lang/index'

export const logging = (data, loadingOptions) => httpRequest.httpPost('/service/j_spring_security_check', data, loadingOptions)

/**
 * @GET
 * @param {*} params 传递的参数
 *
 */
// brian 2021.4.26
export const mpDetailFn = (params = {}) => httpRequest.httpGet({
  url: '/service/dm/mpDetail',
  params: {
    ...params
  }
})
export const userLoginOut = (params = {}) => httpRequest.httpGet({
  url: '/service/user/logout',
  params: {
    ...params
  }
})
export const checkKeyOnly = (params = {}) => httpRequest.httpGet({
  url: '/service/frameForward/checkKeyOnly',
  params: {
    ...params
  }
})
export const gpsInfo = (params = {}) => httpRequest.httpGet({
  url: '/service/gps/info',
  params: {
    ...params
  }
})
export const gpsMap = (params = {}) => httpRequest.httpGet({
  url: '/service/gps/map',
  params: {
    ...params
  }
})
export const gpsIds = (params = {}) => httpRequest.httpGet({
  url: '/service/gps/di',
  params: {
    ...params
  }
})
export const sensorStatus = (params = {}) => httpRequest.httpGet({ // 传感器状态
  url: '/service/common/params/sensor_status',
  params: {
    ...params
  }
})
// 获取传感器的系统默认传输间隔
export const defaultInterval = (params = {}) => httpRequest.httpGet({
  url: '/service/sensor/defaultInterval',
  params: {
    ...params
  }
})
export const sensorType = (params = {}) => httpRequest.httpGet({
  url: '/service/common/params/sensor_type',
  params: {
    ...params
  }
})
export const gatewayStatus = (params = {}) => httpRequest.httpGet({ // 网关状态
  url: '/service/common/params/gateway_status',
  params: {
    ...params
  }
})
export const TerminalAll = (params = {}) => httpRequest.httpGet({
  url: '/service/terminal/terminal',
  params: {
    ...params
  }
})
export const getAlarmObject = (params = {}) => httpRequest.httpGet({
  url: '/service/alarmObject/getAlarmObject',
  params: {
    ...params
  }
})
export const isExist = (params = {}) => httpRequest.httpGet({
  url: '/service/alarmGroup/isExist',
  params: {
    ...params
  }
})
export const setTerminalTime = (data, loadingOptions) => httpRequest.httpPut('/service/terminal/setTerminalTime', data)
export const sureRecordPut = (data, loadingOptions) => httpRequest.httpPut('/service/terminal/sureRecord' + `?ids=${data.ids}&scopeId=${data.scopeId}`)
export const getConfigInstanceSort = (data, loadingOptions) => httpRequest.httpPut('/service/monitorInstance/orderMonitor', data)
// 快捷栏
export const saveIndexQuickBar = (data) => httpRequest.httpPost('/service/index/saveIndexQuickBar', data)

// date:2021-08-10 系统导向
export const saveSystemGuideDevice = (data) => httpRequest.httpPost('/service/systemGuide/saveSystemGuideDevice', data)
export const saveSystemGuideCarrier = (data) => httpRequest.httpPost('/service/systemGuide/saveSystemGuideCarrier', data)
export const saveSystemGuideIndicator = (data) => httpRequest.httpPost('/service/systemGuide/saveSystemGuideIndicator', data)
export const saveSystemGuideDeviceBind = (data) => httpRequest.httpPost('/service/systemGuide/saveSystemGuideDeviceBind', data)
export const saveSystemGuideAlarmGroup = (data) => httpRequest.httpPost('/service/systemGuide/saveSystemGuideAlarmGroup', data)
export const getSystemGuideId = (params = {}) => httpRequest.httpGet({
  url: '/service/systemGuide/getSystemGuideId',
  params: {
    ...params
  }
})
export const findSystemGuideDeviceByGuideId = (params = {}) => httpRequest.httpGet({
  url: '/service/systemGuide/findSystemGuideDeviceByGuideId',
  params: {
    ...params
  }
})
export const findSystemGuideCarrierByGuideId = (params = {}) => httpRequest.httpGet({
  url: '/service/systemGuide/findSystemGuideCarrierByGuideId',
  params: {
    ...params
  }
})
export const findSystemGuideIndicatorByGuideId = (params = {}) => httpRequest.httpGet({
  url: '/service/systemGuide/findSystemGuideIndicatorByGuideId',
  params: {
    ...params
  }
})
export const findSystemGuideDeviceBindByGuideId = (params = {}) => httpRequest.httpGet({
  url: '/servicesystemGuide/findSystemGuideDeviceBindByGuideId',
  params: {
    ...params
  }
})
// 向导传感器根据范围查询
export const getPageForUnBindSensor = (params = {}) => httpRequest.httpGet({
  url: '/service/sensor/lst/getPageForUnBindSensor',
  params: {
    ...params
  }
})
export const getAlarmObjectNoticeBySceneId = (params = {}) => httpRequest.httpGet({
  url: '/service/alarmGroup/getAlarmObjectNoticeBySceneId',
  params: {
    ...params
  }
})
// 向导网关根据范围查询
export const getUnBindGateway = (params = {}) => httpRequest.httpGet({
  url: '/service/gateway/lst/getUnBindGateway',
  params: {
    ...params
  }
})
// 向导显示屏根据范围查询
export const getBindAndUnBindTerminal = (params = {}) => httpRequest.httpGet({
  url: '/service/terminal/lst/getBindAndUnBindTerminal',
  params: {
    ...params
  }
})
// 引导的数据源分页
export const dataSourceFindOnePage = (params = {}) => httpRequest.httpGet({
  url: '/service/guide_instance/data_source/findOnePage',
  params: {
    ...params
  }
})
// 懒加载
export const dataSourceFindAllEl = (params = {}) => httpRequest.httpGet({
  url: '/service/guide_instance/data_source/findAllEl',
  params: {
    ...params
  }
})
// 获取所有页面数据源
export const dataSourceFindAllPage = (params = {}) => httpRequest.httpGet({
  url: '/service/guide_instance/data_source/findAllPage',
  params: {
    ...params
  }
})
// 获取信息
export const dataSourceFindById = (params = {}) => httpRequest.httpGet({
  url: '/service/guide_instance/data_source/findById',
  params: {
    ...params
  }
})
// 2021-10-08 向导3.0版本
// 获取初始化用户向导状态表数据
export const getInitStateData = (params = {}) => httpRequest.httpGet({
  url: '/service/systemGuideContent/getInitStateData',
  params: {
    ...params
  }
})
// 系统向导上一步获取数据
export const getPreviousStepData = (params = {}) => httpRequest.httpGet({
  url: '/service/systemGuideContent/getPreviousStepData',
  params: {
    ...params
  }
})
// 系统向导获取未确认的显示屏
export const getUnknownTerminal = (params = {}) => httpRequest.httpGet({
  url: '/service/terminal/lst/getUnknownTerminal',
  params: {
    ...params
  }
})

// 系统向导获取架构节点的温区和湿区列表
export const getStepFourRangeList = (params = {}) => httpRequest.httpGet({
  url: '/service/systemGuideContent/getStepFourRangeList',
  params: {
    ...params
  }
})

//  下一步保存向导内容
export const saveSystemGuideContent = (data) => httpRequest.httpPost('/service/systemGuideContent/saveContent', data)
//  更新当前步的内容
export const updateSystemGuideContent = (data) => httpRequest.httpPost('/service/systemGuideContent/updateContent', data)

// 新增数据源
export const dataSourceAdd = (data) => httpRequest.httpPost('/service/guide_instance/data_source/add', data)
// 删除数据源
export const dataSourceDel = (data, loadingOptions) => httpRequest.httpdelete('/service/guide_instance/data_source/delete', data, loadingOptions)
// 修改数据源
export const dataSourceUpdate = (data, loadingOptions) => httpRequest.httpPut('/service/guide_instance/data_source/update', data)
// 传感器未确认的下载模板
export const sensorExporttSensor = (params = {}) => httpRequest.download('/service/sensor/generaUploadTemplateFile', params)
// 下载网关模板
export const gatewayImportGateway = (params = {}) => httpRequest.download('/service/gateway/generaUploadTemplateFile', params)
// 导入网关模板
export const generaUploadTemplateFile = (data, language) => httpRequest.httpPost('/service/gateway/importGateway?language=' + language.language, data)
// 上传传感器
export const sensorImportSensor = (data, language) => httpRequest.httpPost('/service/sensor/importSensor', data)

// 显示屏未确认上传
export const terminalExporttSensor = (params = {}) => httpRequest.download('/service/terminal/generaUploadTemplateFile', params)
// 上传显示屏
export const terminalImportSensor = (data, language) => httpRequest.httpPost('/service/terminal/importTerminal?language=' + language.language, data)
// 未确认传感器的新增
export const sensorAddSensor = (data) => httpRequest.httpPost('/service/sensor/addSensor', data)
// 未确认传感器的详情
export const sensorGetSensorDetailInfo = (params = {}) => httpRequest.httpGet({
  url: '/service/sensor/getSensorDetailInfo',
  params: {
    ...params
  }
})
// 未确认顯示屏的新增
export const terminalAddTerminal = (data) => httpRequest.httpPost('/service/terminal/addTerminal', data)
// 未确传感器根据设备类型修改
export const sensorUptConfig = (data) => httpRequest.httpPut('/service/sensor/uptConfig', data)

// 中继分页
export const relayLst = (params = {}, way) => httpRequest.httpGet(
  {
    url: '/service/relay/lst/' + way,
    params: {
      ...params
    }
  })
// 中继详情
export const relayFindById = (params = {}, way) => httpRequest.httpGet(
  {
    url: '/service/relay/findById',
    params: {
      ...params
    }
  })
// 中继恢复运行
export const relayResume = (data) => httpRequest.httpPut('/service/relay/resume?id=' + data)
// 中继新增
export const relayAdd = (data) => httpRequest.httpPost('/service/relay/add', data)
// 中继编辑
export const relayUpt = (data) => httpRequest.httpPut('/service/relay/upt', data)
// 中继删除
export const relayDel = (data, loadingOptions) => httpRequest.httpdelete('/service/relay/del', data)
// 下载中继模板
export const relayGeneraUploadTemplateFile = (params = {}) => httpRequest.download('/service/relay/generaUploadTemplateFile', params)
// 上传中继模板
export const relayImportRelay = (data, language) => httpRequest.httpPost('/service/relay/importRelay?language=' + language.language, data)

// 迭代二期需求
// 获取传感器的参数详情
export const sensorGetConfig = (params = {}, way) => httpRequest.httpGet(
  {
    url: '/service/deviceConfig/sensor/getConfig',
    params: {
      ...params
    }
  })
// 获取网关的参数详情
export const gatewayGetConfig = (params = {}, way) => httpRequest.httpGet(
  {
    url: '/service/deviceConfig/gateway/getConfig',
    params: {
      ...params
    }
  })

// 根据id查询网关信息
export const gatewayGetid = (params = {}, way) => httpRequest.httpGet(
  {
    url: '/service/gateway/' + params.id,
    params: {
      ...params
    }
  })
// 获取显示屏的参数详情
export const terminalGetConfig = (params = {}, way) => httpRequest.httpGet(
  {
    url: '/service/deviceConfig/terminal/getConfig',
    params: {
      ...params
    }
  })
// 获取中继的参数详情
export const relayGetConfig = (params = {}, way) => httpRequest.httpGet(
  {
    url: '/service/deviceConfig/relay/getConfig',
    params: {
      ...params
    }
  })
// 保存传感器应用参数
export const sensorSaveAppConfig = (data, isEdited) => httpRequest.httpPost('/service/deviceConfig/sensor/saveAppConfig?isEdited=' + isEdited, data)
// 保存传感器网络参数
export const sensorSaveInternetConfig = (data, isEdited) => httpRequest.httpPost('/service/deviceConfig/sensor/saveInternetConfig?isEdited=' + isEdited, data)
// 重启网关
export const gatewayRestart = (data, isEdited) => httpRequest.httpPost('/service/deviceConfig/gateway/restartGateway?isEdited=' + isEdited, data)
// 保存网关网络参数
export const gatewaySaveInternetConfig = (data, isEdited) => httpRequest.httpPost('/service/deviceConfig/gateway/saveInternetConfig?isEdited=' + isEdited, data)
// 保存显示屏应用参数
export const terminalSaveAppConfig = (data, isEdited) => httpRequest.httpPost('/service/deviceConfig/terminal/saveAppConfig?isEdited=' + isEdited, data)
// 保存显示屏网络参数
export const terminalSaveInternetConfig = (data, isEdited) => httpRequest.httpPost('/service/deviceConfig/terminal/saveInternetConfig?isEdited=' + isEdited, data)
// 保存中继网络参数
export const relaySaveInternetConfig = (data, isEdited) => httpRequest.httpPost('/service/deviceConfig/relay/saveInternetConfig?isEdited=' + isEdited, data)

// 传感器的设备日志
export const deviceConfigRecord = (params = {}) => httpRequest.httpGet(
  {
    url: '/service/deviceConfigRecord/getRecord',
    params: {
      ...params
    }
  })
// 传感器删除命令
export const deleteConfig = (params = {}) => httpRequest.httpGet(
  {
    url: '/service/deviceConfigRecord/deleteConfig',
    params: {
      ...params
    }
  })
// 传感器删除记录
export const deleteRecord = (data) => httpRequest.httpdelete('/service/deviceConfigRecord/deleteRecord', data)

// 查询子记录信息

export const deviceConfigRecordGetHistory = (params = {}) => httpRequest.httpGet(
  {
    url: '/service/deviceConfigRecord/getHistory',
    params: {
      ...params
    }
  })
//  向导的第n版接口 校验网关是否存在
export const checkGatewayIsExist = (data) => httpRequest.httpPost('/service/gateway/checkGatewayIsExist', data)
//  向导的第n版接口 校验传感器是否存在
export const checkSensorIsExist = (data) => httpRequest.httpPost('/service/sensor/checkSensorIsExist', data)
//  向导的第n版接口 校验显示屏是否存在
export const checkTerminalIsExist = (data) => httpRequest.httpPost('/service/terminal/checkTerminalIsExist', data)
//  向导的第n版接口 校验指标是否存在
export const checkRangeIsExist = (data) => httpRequest.httpPost('/service/monitorRange/checkRangeIsExist', data)
//  向导的第n版接口 校验载体是否存在
export const checkCarrierIsExist = (data) => httpRequest.httpPost('/service/systemGuide/checkCarrierIsExist', data)
//  向导的第n版接口 校验一组载体是否存在
export const checkCarrierArrayIsExist = (data) => httpRequest.httpPost('/service/atomCarrier/checkCarrierListIsExist', data)
export const checkIndicatorArrayIsExist = (data) => httpRequest.httpPost('/service/monitorRange/checkRangeListIsExist', data)
// 引导功能的总开关
export const guideMasterSwitch = (params = {}) => httpRequest.httpGet(
  {
    url: '/service/guide_instance/masterSwitch',
    params: {
      ...params
    }
  })
// 向导的架构树删除接口
export const deleteSystemGuideScene = (data) => httpRequest.httpPost('/service/systemGuide/deleteSystemGuideScene', data)
// 向导的架构树的新增
export const systemGuideAddScene = (data) => httpRequest.httpPost('/service/systemGuide/addScene', data)
// 显示屏的恢复
export const terminalResume = (data) => httpRequest.httpPut('/service/terminal/resume?id=' + data)
// 向导获取已应用的载体数据
export const saveSceneCarrierCache = (data) => httpRequest.httpPost('/service/systemGuide/saveSceneCarrierCache', data)
// 向导应用载体数据
export const getSceneCarrierCache = (params = {}) => httpRequest.httpGet(
  {
    url: '/service/systemGuide/getSceneCarrierCache',
    params: {
      ...params
    }
  })

/**
 * @description: 迭代五期的AT指令功能
 * @param {*params} 接口所需参数
 * @return {*}
 */
export const gatewayGetAT = (params = {}) => httpRequest.httpGet(
  {
    url: '/service/deviceConfig/gateway/getAT',
    params: {
      ...params
    }
  })
export const gatewaysendAT = (data) => httpRequest.httpPost('/service/deviceConfig/gateway/sendAT', data)

// 迭代7
export const userSwitchScope = (params = {}) => httpRequest.httpGet(
  {
    url: '/service/userInfo/switchScope',
    params: {
      ...params
    }
  })
/** 打印设置  */
export const printGroupList = (params = {}) => httpRequest.httpGet(
  {
    url: '/service/printGroup/list',
    params: {
      ...params
    }
  })
export const printGroupInfo = (params = {}) => httpRequest.httpGet(
  {
    url: '/service/printer/info',
    params: {
      ...params
    }
  })
export const printInfo = (params = {}) => httpRequest.httpGet(
  {
    url: '/service/printGroup/info',
    params: {
      ...params
    }
  })
export const printAddGroup = (data) => httpRequest.httpPost('/service/printGroup/addPrintGroup', data)
export const printGroupSave = (data) => httpRequest.httpPost('/service/printGroup/save', data)
export const checkPrintGroup = (data) => httpRequest.httpPost('/service/printGroup/checkPrintGroup?groupName=' + data.groupName)
export const updateGroupName = (data) => httpRequest.httpPost('/service/printGroup/updateGroupName', data)
export const printGroupDelete = (data) => httpRequest.httpdelete('/service/printGroup/delete', data)

/*
以下另外的前端
*/

// 公共树形菜单接口
export const rolerighttree = (params = {}) => httpRequest.httpGet({
  url: '/service/treeUtil/tree',
  params: {
    ...params
  }
})
export const userinfomenu = (params = {}) => httpRequest.httpGet({
  url: '/service/account/info',
  params: {
    ...params
  }
})
// 公共设备类型
export const getTypes = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrierExtend/getTypes',
  params: {
    ...params
  }
})

// 下拉框接口
export const worktask = (params = {}) => httpRequest.httpGet({
  url: '/service/task/tasks',
  params: {
    // type: params.type,
    ...params
  }
})

// 个人权限树信息
export const permissionTreeInfo = (params = {}) => httpRequest.httpGet({
  url: '/service/role/righttree',
  params: {
    // type: params.type,
    ...params
  }
})

// 个人档案资料
export const userInfo = (params = {}) => httpRequest.httpGet({
  url: '/service/userInfo/me',
  params: {
    // type: params.type,
  }
})

// 个人档案 获取个人权限树信息
export const userInfoTree = (params = {}) => httpRequest.httpGet({
  url: '/service/userInfo/tree',
  params: {
    ...params
  }
})
// export const userInfoTree = (params = {}) => httpRequest.httpGet({
//   url: '/service/core/userInfo|tree', params: {
//     ...params
//   }
// })

export const syscustom = (params = {}) => httpRequest.httpGet({
  url: '/service/syscustom/getOne',
  params: {
    type: params.type
  }
})

// 用户信息  +  查询
export const accountList = (params = {}) => httpRequest.httpGet({
  url: '/service/account/lst',
  params: {
    ...params
  }
})

// 编辑详情
export const userDetails = (params = {}) => httpRequest.httpGet({
  url: `/service/account/${params.id}`,
  params: {
    ...params
  }
})

export const userUnitTree = (params = {}) => httpRequest.httpGet({
  url: '/service/scene/userUnitTree',
  params: {
    ...params
  }
})

// 新增用户时获取所有架构
export const allNode = (params = {}) => httpRequest.httpGet({
  url: '/service/scene/allNode',
  params: {
    depth: 'entity'
  }
})

// 新增- 角色选取
export const selectrole = (params = {}) => httpRequest.httpGet({
  url: '/service/account/role',
  params: {
    ...params /// service/core/role|user|auth
  }
})
// export const selectrole = (params = {}) => httpRequest.httpGet({
//   url: '/service/account/role', params: {
//     ...params ///service/core/role|user|auth
//   }
// })

//  用户管理模块  角色权限列表
export const allRole = (params = {}) => httpRequest.httpGet({
  url: '/service/role/lst',
  params: {
    ...params
  }
})
//  用户管理模块  角色权限列表
// export const allRole = (params = {}) => httpRequest.httpGet({
//   url: '/service/role/all', params: {
//     ...params
//   }
// })
// 获取未拥有的角色
export const unextendRole = (params = {}) => httpRequest.httpGet({
  url: '/service/role/unextend',
  params: {
    ...params
  }
})

//
//  设备管理模块 -  架构树列表
export const sensorTree = (params = {}) => httpRequest.httpGet({
  url: '/service/sensor/tree',
  params: {
    ...params
  }
})

export const getConfig = (params = {}) => httpRequest.httpGet({
  url: '/service/sensor/getConfig',
  params: {
    ...params
  }
})

// 传感器列表分页信息
export const sensorList = (params = {}, way) => httpRequest.httpGet({
  url: `/service/sensor/lst/${way}`,
  params: {
    ...params
  }
})

// 传感器 显示屏列表页时，获取左侧架构树

export const terminal = (params = {}) => httpRequest.httpGet({
  url: '/service/terminal/tree',
  params: {
    ...params
  }
})

export const screenlst = (params = {}, way) => httpRequest.httpGet({
  url: '/service/terminal/lst/' + way,
  params: {
    ...params
  }
})

// 通过ID获取显示屏信息
export const sensorinformation = (params = {}) => httpRequest.httpGet({
  url: `/service/terminal/${params.id}`,
  params: {
    ...params
  }
})

// 网关路由
export const gatewaytree = (params = {}) => httpRequest.httpGet({
  url: '/service/gateway/tree',
  params: {
    ...params
  }
})

// 网关路由列表分页信息 way
export const gatewayList = (params = {}, way) => httpRequest.httpGet({
  url: `/service/gateway/lst/${way}`,
  params: {
    ...params
  }
})

export const gatewayHistory = (params = {}) => httpRequest.httpGet({
  url: '/service/gatewayHistory/lst',
  params: {
    ...params
  }
})

export const atomCarrier = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/tree',
  params: {
    ...params
  }
})
export const Carrierlst = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/lst',
  params: {
    ...params
  }
})
export const getCarrierType = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/getCarrierType',
  params: {
    ...params
  }
})

// 通过ID获取显示屏信息
export const paramType = (params = {}) => httpRequest.httpGet({
  url: `/service/param/paramType/${params.type}`,
  params: {
    ...params
  }
})

// 载体界面
export const CgetDetail = (params = {}) => httpRequest.httpGet({
  url: '/service/alarmGroup/getDetail',
  params: {
    ...params
  }
})

export const CarrierInfo = (params = {}) => httpRequest.httpGet({
  url: `/service/atomCarrier/${params.id}`,
  params: {
    ...params
  }
})

// 实时数据
export const realtimedata = (params = {}) => httpRequest.httpGet({
  url: '/service/monitor/realtime',
  params: {
    ...params
  }
})

export const sensorxq = (params = {}, id) => httpRequest.httpGet({
  url: '/service/sensor/' + id,
  params: {
    ...params
  }
})
export const sensorInfo = (params = {}) => httpRequest.httpGet({
  url: '/service/sensor/' + params.id,
  params: {}
})

export const dataReport = (params = {}) => httpRequest.httpGet({
  url: '/service/dataReport/scene',
  params: {
    ...params
  }
})
export const dataReportpie = (params = {}) => httpRequest.httpGet({
  url: '/service/dataReport/pie',
  params: {
    ...params
  }
})
export const checkPie = (params = {}) => httpRequest.httpGet({
  url: '/service/dataReport/checkPie',
  params: {
    ...params
  }
})
export const Reportcarrier = (params = {}) => httpRequest.httpGet({
  url: '/service/dataReport/carrier',
  params: {
    ...params
  }
})
export const getCarrierTree = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/getCarrierTree',
  params: {
    ...params
  }
})
export const lstFile = (params = {}) => httpRequest.httpGet({
  url: '/service/downhistory/lstFile',
  params: {
    ...params
  }
})
export const download = (params = {}) => httpRequest.httpGet({
  url: '/service/downhistory/download',
  params: {
    ...params
  }
})
export const alarmObjectlst = (params = {}) => httpRequest.httpGet({
  url: '/service/alarmObject/lst',
  params: {
    ...params
  }
})
export const newUserInfo = (params = {}) => httpRequest.httpGet({
  url: '/service/userInfo/new',
  params: {
    ...params
  }
})

export const alarmRecordLst = (params = {}) => httpRequest.httpGet({
  url: '/service/alarmRecord/lst',
  params: {
    ...params
  }
})
export const getRepairPage = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/repair/getRepairPage',
  params: {
    ...params
  }
})
export const reasonOps = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/reasonOps',
  params: {
    ...params
  }
})

// export const alarmgetId = (params = {}) => httpRequest.httpGet({
//   url: '/service/alarmGrade/getId', params: {
//     ...params 作废
//   }
// })
export const alarmGroupgetId = (params = {}) => httpRequest.httpGet({
  url: '/service/alarmGroup/getId',
  params: {
    ...params
  }
})

export const historylis = (params = {}, id) => httpRequest.httpGet({
  url: `/service/history/findAllByExceptionRecordId/${id}`,
  params: {
    ...params
  }
})

// 数字字典
export const getReasons = (params = {}) => httpRequest.httpGet({
  url: '/service/alarmRecord/getReasons',
  params: {
    ...params
  }
})
export const getCarrierTypes = (params = {}) => httpRequest.httpGet({
  url: '/service/alarmRecord/getCarrierTypes',
  params: {
    ...params
  }
})
export const alarmTypes = (params = {}) => httpRequest.httpGet({
  url: '/service/alarmRecord/alarmTypes',
  params: {
    ...params
  }
})
export const userCerificate = (params = {}) => httpRequest.httpGet({
  url: '/service/userCerificate/lst',
  params: {
    ...params
  }
})
export const getuserSignature = (params = {}) => httpRequest.httpGet({
  url: '/service/userSignature/get',
  params: {
    ...params
  }
})
export const userCertificate = (params = {}) => httpRequest.httpGet({
  url: '/service/userCertificate/lst',
  params: {
    ...params
  }
})
export const voucherImg = (params = {}) => httpRequest.httpGet({
  url: '/service/userCertificate/get',
  params: {
    ...params
  }
})

// 架构
export const frameworkTree = (params = {}) => httpRequest.httpGet({
  url: '/service/scene/allNode',
  params: {
    ...params
  }
})
export const scenebasic = (params = {}) => httpRequest.httpGet({
  url: '/service/scene/basic',
  params: {
    ...params
  }
})
export const scenedetail = (params = {}) => httpRequest.httpGet({
  url: '/service/scene/detail',
  params: {
    ...params
  }
})
export const sceneDetail = (params = {}) => httpRequest.httpGet({
  url: '/service/dm/sceneDetail',
  params: {
    ...params
  }
})
export const getDeviceMap = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/getDeviceMap',
  params: {
    ...params
  }
})
export const generate = (params = {}) => httpRequest.httpGet({
  url: '/service/gm/generate',
  params: {
    ...params
  }
})
export const refresh = (params = {}) => httpRequest.httpGet({
  url: '/service/gm/refresh',
  params: {
    ...params
  }
})
export const listTree = (params = {}) => httpRequest.httpGet({
  url: '/service/gm/tree',
  params: {
    ...params
  }
})
export const finish = (params = {}) => httpRequest.httpGet({
  url: '/service/downhistory/finish',
  params: {
    ...params
  }
})

export const dataReporcd = (params = {}) => httpRequest.httpGet({
  url: '/service/dataReport/cd',
  params: {
    ...params
  }
})
export const getSensorLine = (params = {}) => httpRequest.httpGet({
  url: '/service/dataReport/getSensorLine',
  params: {
    ...params
  }
})
// 系统设置
export const settingshow = (params = {}) => httpRequest.httpGet({
  url: '/service/setting/show',
  params: {
    // type: params.type,
    ...params
  }
})
export const checkFile = (params = {}) => httpRequest.httpGet({
  url: '/service/dataReport/checkFile',
  params: {
    // type: params.type,
    ...params
  }
})
export const detailsFile = (params = {}) => httpRequest.httpGet({
  url: '/service/dataReport/details',
  params: {
    ...params
  }
})
export const sensorgenerate = (params = {}) => httpRequest.httpGet({
  url: '/service/gm/sensorgenerate',
  params: {
    ...params
  }
})

export const getExtendOps = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/extend/getExtendOps',
  params: {
    ...params
  }
})
export const atomtypes = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/types',
  params: {
    ...params
  }
})

export const getConfigInstance = (params = {}) => httpRequest.httpGet({
  url: '/service/monitorInstance/getConfig',
  params: {
    ...params
  }
})
export const getConfigInstanceDetail = (params = {}) => httpRequest.httpGet({
  url: '/service/monitorInstance/getConfigDetail',
  params: {
    ...params
  }
})

export const getInstances = (params = {}) => httpRequest.httpGet({
  url: '/service/monitorInstance/getInstances',
  params: {
    ...params
  }
})
export const carrierscene = (params = {}) => httpRequest.httpGet({
  url: '/service/scene/scene',
  params: {
    ...params
  }
})
export const exceptionlst = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/exception/lst',
  params: {
    ...params
  }
})
export const CurrentUserinfo = (params = {}) => httpRequest.httpGet({
  url: '/service/user/info',
  params: {
    ...params
  }
})
export const getRecordTime = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/getRecordTime',
  params: {
    ...params
  }
})
export const getGlobalTime = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/getGlobalTime',
  params: {
    ...params
  }
})
export const paramTypes = (params = {}) => httpRequest.httpGet({
  url: '/service/param/paramType/CARRIER_STATUS',
  params: {
    ...params
  }
})

// 计划任务分页
export const emailnoticelog = (params = {}) => httpRequest.httpGet({
  url: '/service/task/lst',
  params: {
    // type: params.type,
    ...params
  }
})
// 操作任务（只运行一次）
export const operatingDuty = (params = {}) => httpRequest.httpGet({
  url: '/service/task/status/run',
  params: {
    ...params
  }
})
export const deletetask = (data, loadingOptions) => httpRequest.httpdelete('/service/task/del', data, loadingOptions)
export const sceneposdel = (data, loadingOptions) => httpRequest.httpdelete('/service/scene/pos/del', data, loadingOptions)
// 新增任务
export const addtask = (data, loadingOptions) => httpRequest.httpPost('/service/task/add', data, loadingOptions)

export const roleInfo = (params = {}) => httpRequest.httpGet({
  url: `/service/role/${params.id}`,
  params: {
    ...params
  }
})

export const SensorExport = (params = {}) => httpRequest.httpGet({
  url: '/service/AtomCarrierSensorExportRecord/lst',
  params: {
    ...params
  }
})
// 温度采集
export const atomCarrierTime = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/getGlobalTime',
  params: {
    ...params
  }
})
export const sensorstat = (params = {}) => httpRequest.httpGet({
  url: '/service/sensor/stat',
  params: {
    ...params
  }
})
export const getRangeOptions = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/getRangeOptions',
  params: {
    ...params
  }
})
export const userSignatureget = (params = {}) => httpRequest.httpGet({
  url: '/service/userSignature/get',
  params: {
    ...params
  }
})
export const generates = (url, data, name) => httpRequest.download('/service/AtomCarrierSensorExportRecord/generate', url, data, name)

export const getExpor = (params = {}) => httpRequest.httpGet({
  url: '/service/AtomCarrierSensorExportRecord/generate',
  params: {
    ...params
  }
})
export const listgmgenerate = (params = {}) => httpRequest.httpGet({
  url: '/service/gm/generate',
  params: {
    ...params
  }
})

export const loadgenerate = (url, data, name) => httpRequest.download('/service/gm/generate', url, data, name)
export const chartDownload = (url, data, name) => httpRequest.download('/service/downhistory/chartDownload', url, data, name)

export const assignauth = (params = {}) => httpRequest.httpGet({
  url: '/service/role/assign/auth',
  params: {
    ...params
  }
})
export const oldUserInfo = (params = {}) => httpRequest.httpGet({
  url: '/service/userInfo/isAuthing',
  params: {
    ...params
  }
})
export const findOnePage = (params = {}) => httpRequest.httpGet({
  url: '/service/carrierOperateRecord/findOnePage',
  params: {
    ...params
  }
})
export const exportRecordReport = (params = {}) => httpRequest.httpGet({
  url: '/service/carrierOperateRecord/exportRecordReport',
  params: {
    ...params
  }
})
export const scenegetDeviceMap = (params = {}) => httpRequest.httpGet({
  url: '/service/scene/getDeviceMap',
  params: {
    ...params
  }
})
export const frameForward = (params = {}) => httpRequest.httpGet({
  url: '/service/frameForward/lst',
  params: {
    ...params
  }
})
export const atomCarrierOptions = (params = {}) => httpRequest.httpGet({
  url: '/service/atomCarrier/getRangeOptions',
  params: {
    ...params
  }
})
export const DownReport = (url, data, name) => httpRequest.download('/service/carrierOperateRecord/exportRecordReport', url, data, name)
export const demandId = (params = {}) => httpRequest.httpGet({
  url: '/service/carrierOperateRecord/' + params.id,
  params: {
    // ...params
  }
})

// export const rolerighttree = (params = {}) => httpRequest.httpGet({
//   url: '/service/role/righttree', params: {
//     ...params
//   }
// })
// mqtt分页查询
export const mqttTable = (params = {}) => httpRequest.httpGet({
  url: '/service/mqttServer/findOnePage',
  params: {
    ...params
  }
})
// 获取mqtt的apikey
export const mqttKey = (params = {}) => httpRequest.httpGet({
  url: '/service/mqttServer/getZetaParam',
  params: {
    ...params
  }
})
// 测试mqtt是否断开
export const testConnect = (params = {}) => httpRequest.httpGet({
  url: '/service/mqttServer/testConnect',
  params: {
    ...params
  }
})
// clientId的校验
export const ruleT = (params = {}) => httpRequest.httpGet({
  url: '/service/mqttServer/checkHostExist',
  params: {
    ...params
  }
})
// 根据id获取详情
export const mqttKeyId = (params = {}) => httpRequest.httpGet({
  url: '/service/mqttServer/findById/' + `${params}`
})
// 传感器zeta记录分页接口
export const zetaRecoedPage = (params = {}) => httpRequest.httpGet({
  url: '/service/sensor/findOnePageZeta',
  params: {
    ...params
  }
})
// 根据zeta的id获取数据
export const getZetaConfig = (params = {}) => httpRequest.httpGet({
  url: '/service/sensor/getZetaConfig',
  params: {
    ...params
  }
})
// zeta下发
export const sendZetaConfig = (params = {}) => httpRequest.httpGet({
  url: '/service/sensor/sendZetaConfig',
  params: {
    ...params
  }
})
// 导出
export const sensorgenerates = (params = {}) => httpRequest.exportPostGet({
  url: '/service/gm/sensorgenerate',
  params: {
    ...params
  }
})

// 首页布局
export const getIndexLayoutContent = (params = {}) => httpRequest.httpGet({
  url: '/service/index/getIndexLayoutContent',
  params: {
    ...params
  }
})
export const getUserIndexTemplate = (params = {}) => httpRequest.httpGet({
  url: '/service/index/getUserIndexTemplate',
  params: {
    ...params
  }
})
export const carrierStatusStat = (params = {}) => httpRequest.httpGet({
  url: '/service/index/carrierStatusStat',
  params: {
    ...params
  }
})
export const alarmRecordTypeStat = (params = {}) => httpRequest.httpGet({
  url: '/service/index/alarmRecordTypeStat',
  params: {
    ...params
  }
})
export const alarmStatu = (params = {}) => httpRequest.httpGet({
  url: '/service/index/alarmRecordStatusStat',
  params: {
    ...params
  }
})
export const sensorStatusStat = (params = {}) => httpRequest.httpGet({
  url: '/service/index/sensorStatusStat',
  params: {
    ...params
  }
})
export const gatewayStatusStatt = (params = {}) => httpRequest.httpGet({
  url: '/service/index/gatewayStatusStat',
  params: {
    ...params
  }
})
export const alarmNoticeTypeStat = (params = {}) => httpRequest.httpGet({
  url: '/service/index/alarmNoticeTypeStat',
  params: {
    ...params
  }
})
export const getAlarmRecordByLatest = (params = {}) => httpRequest.httpGet({
  url: '/service/index/getAlarmRecordByLatest',
  params: {
    ...params
  }
})

export const getSensorRecordByCarrierId = (params = {}) => httpRequest.httpGet({
  url: '/service/index/getSensorRecordByCarrierId',
  params: {
    ...params
  }
})
export const passRateStat = (params = {}) => httpRequest.httpGet({
  url: '/service/index/passRateStat',
  params: {
    ...params
  }
})
// 用户权限树的接口

// export const treeUtil = (params = {}) => httpRequest.httpGet({
//   url: '/service/treeUtil/tree', params: {
//     ...params
//   }
// })
// 权限用户分配
export const roleAssign = (params = {}) => httpRequest.httpGet({
  url: '/service/role/assign',
  params: {
    ...params
  }
})
// 权限查找所有的范围
export const accessRangeFindAll = (params = {}) => httpRequest.httpGet({
  url: '/service/accessRange/findAll',
  params: {
    ...params
  }
})
// 分页范围接口
export const accessRangePage = (params = {}) => httpRequest.httpGet({
  url: '/service/accessRange/findOnePage',
  params: {
    ...params
  }
})
// 用户管理的范围树
// export const accessRangeTree = (params = {}) => httpRequest.httpGet({
//   url: '/service/accessRange/accessRangeTree', params: {
//     ...params
//   }
// })
export const accessRangeTree = (params = { local: i18n.locale }) => httpRequest.httpGet({
  url: '/service/share/scope',
  params: {
    ...params
  }
})
// 用户管理的架构树
// export const treeUtilTree = (params = {}) => httpRequest.httpGet({
//   url: '/service/treeUtil/tree', params: {
//     ...params
//   }
// })

export const frameForwardpage = (params = {}) => httpRequest.httpGet({
  url: '/service/frameForward/page',
  params: {
    ...params
  }
})
export const alarmRecorddt = (params = {}) => httpRequest.httpGet({
  url: '/service/alarmRecord/dt',
  params: {
    ...params
  }
})

export const frameForwarddetail = (params = {}) => httpRequest.httpGet({
  url: '/service/frameForward/detail?id=' + params.id,
  params: {
    ...params
  }
})

/**
 * @POST
 * @param {*} params
 *
 */

// export const append = params => httpRequest.httpPost('/service/account/role', params) /service/account/add
// 新增角色
export const append = (data, loadingOptions) => httpRequest.httpPost('/service/account/add', data, loadingOptions)

// 角色权限新增角色
export const addRole = (data, loadingOptions) => httpRequest.httpPost('/service/role/add', data, loadingOptions)

export const configParam = (data, loadingOptions) => httpRequest.httpPost('/service/sensor/configParam', data, loadingOptions)

export const sentParam = (data, loadingOptions) => httpRequest.httpPost('/service/sensor/sentParam', data, loadingOptions)

export const addterminal = (data, loadingOptions) => httpRequest.httpPost('/service/terminal/add', data, loadingOptions)

export const blockgateway = (data, loadingOptions) => httpRequest.httpPost('/service/gateway/edit/unused', data, loadingOptions)
export const blockgatewayuse = (data, loadingOptions) => httpRequest.httpPost('/service/gateway/edit/use', data, loadingOptions)
// export const uptStatus = (data, loadingOptions) => httpRequest.httpPost('/service/atomCarrier/uptStatus', data, loadingOptions)
export const atomCarrieradd = (data, loadingOptions) => httpRequest.httpPost('/service/atomCarrier/add', data, loadingOptions)
export const getOneGrade = (data, loadingOptions) => httpRequest.httpPost('/service/atomCarrier/grade/getOneGrade', data, loadingOptions)
export const alarmGroupadd = (data, loadingOptions) => httpRequest.httpPost('/service/alarmGroup/add', data, loadingOptions)
export const alarmObjectadd = (data, loadingOptions) => httpRequest.httpPost('/service/alarmObject/add', data, loadingOptions)
export const addRepair = (data, loadingOptions) => httpRequest.httpPost('/service/atomCarrier/repair/addRepair', data, loadingOptions)
export const postSignature = (data, param) => httpRequest.httpPost('/service/userSignature/save', data, param)
export const addScene = (data, param) => httpRequest.httpPost('/service/scene/addScene', data, param)
export const downloadGrade = (data, param) => httpRequest.httpPost('/service/dataReport/downloadGrade', data, param)
export const checkBar = (data, param) => httpRequest.httpPost('/service/dataReport/bar', data, param)
export const potdbBar = (data, param) => httpRequest.httpPost('/service/dataReport/dbBar', data, param)
export const getCompareDatar = (data, param) => httpRequest.httpPost('/service/atomCarrier/grade/getCompareData', data, param)
export const monitorList = (data, loadingOptions) => httpRequest.httpPost('/service/gm/gd', data, loadingOptions)

export const saveLatLng = (data, param) => httpRequest.httpPost('/service/scene/saveLatLng', data, param)
export const savePost = (data, param) => httpRequest.httpPost('/service/j_spring_security_check', data, param)
export const saveGlobalTime = (data, param) => httpRequest.httpPost('/service/atomCarrier/saveGlobalTime', data, param)
export const SaveRecord = (data, param) => httpRequest.httpPost('service/AtomCarrierSensorExportRecord/upd', data, param)
export const addRecordTime = (data, param) => httpRequest.httpPost('/service/atomCarrier/addRecordTime', data, param)
export const batchSet = (data, param) => httpRequest.httpPost('/service/alarmGroup/batchSet', data, param)
export const userSignaturesave = (data, param) => httpRequest.httpPost('/service/userSignature/save', data, param)
export const batchGenerate = (data, param) => httpRequest.httpPost('/service/AtomCarrierSensorExportRecord/batchGenerate', data, param)
export const checkDbBar = (data, param) => httpRequest.httpPost('/service/dataReport/checkDbBar', data, param)
export const Inspection = (data, param) => httpRequest.httpPost('/service/dataReport/checkBar', data, param)
export const gatewayadd = (data, loadingOptions) => httpRequest.httpPost('/service/gateway/add', data)
export const sensorload = (data, loadingOptions) => httpRequest.httpPost('/service/sensor/load', data)
// export const importGateway = (data, loadingOptions) => httpRequest.httpPost('/service/gateway/importGateway', data)
export const saveUserIndexTemplate = (data, loadingOptions) => httpRequest.httpPost('/service/index/saveUserIndexTemplate', data)

// 文件导出 检查
export const fileStream = (url, data, name) => httpRequest.exportPost('/service/AtomCarrierSensorExportRecord/batchGenerate', url, data, name)
// mqtt的新增接口
export const mqttAdd = (data, param) => httpRequest.httpPost('/service/mqttServer/add', data)
// export const fileStream = (url, data, name) => httpRequest.exportPost('/service/AtomCarrierSensorExportRecord/batchGenerate', url, data, name)

// export const fileStream = (url, data, name) => httpRequest.exportPost('/service/AtomCarrierSensorExportRecord/batchGenerate', url, data, name)
// mqtt的新增接口
// export const mqttAdd = (data, param) => httpRequest.httpPost('/service/mqttServer/add', data)
// 新增范围接口
export const accessRangeAdd = (data, param) => httpRequest.httpPost('/service/accessRange/add', data)

/**
 * @Form data
 * @param {*} data
 */
// 登录
// export const savePost = (data) => {
//   return httpRequest.httpForm({
//     url: '/service/j_spring_security_check',
//     ...data
//   })
// }
export const sceneupload = (data, loadingOptions) => httpRequest.httpForm('/service/scene/upload', data, loadingOptions)
// export const sceneupload = (data, loadingOptions) => httpRequest.httpForm('/service/upload?forward=scene/upload', data, loadingOptions)
export const syscustomload = (data, loadingOptions) => httpRequest.httpForm('/service/upload', data, loadingOptions)
// zeta保存
export const saveZetaConfig = (data, param) => httpRequest.httpPost('/service/sensor/saveZetaConfig?id=' + param, data)

/**
 * @delete  删除
 * @param {*} params
 */
// 删除签名
export const cancellist = (ids) => httpRequest.httpdelete('/service/userSignature/del?ids=' + ids)

// 用户信息 删除
export const rolellist = (data, loadingOptions) => httpRequest.httpdelete('/service/account/del', data, loadingOptions)

// 角色权限 删除
export const deleteRole = (data, loadingOptions) => httpRequest.httpdelete('/service/role/del', data, loadingOptions)

// ids批量删除传感器
export const removeSensor = (data, loadingOptions) => httpRequest.httpdelete('/service/sensor/del', data, loadingOptions)

// 删除显示屏
export const removeScreen = (data, loadingOptions) => httpRequest.httpdelete('/service/terminal/del', data, loadingOptions)

export const removeGateway = (data, loadingOptions) => httpRequest.httpdelete('/service/gateway/del', data, loadingOptions)
// 网关范围确认
export const scopeConfirmGateway = (ids, scopeId) => httpRequest.httpPut(`/service/gateway/updateGatewayScope?ids=${ids}&scopeId=${scopeId}`)
// 传感器范围确认
export const scopeConfirmSensor = (ids, scopeId) => httpRequest.httpPut(`/service/sensor/updateSensorScope?ids=${ids}&scopeId=${scopeId}`)
// 显示屏范围确认
export const scopeConfirmTerminal = (ids, scopeId) => httpRequest.httpPut(`/service/terminal/updateTerminalScope?ids=${ids}&scopeId=${scopeId}`)

export const atomCarrierdel = (data, loadingOptions) => httpRequest.httpdelete('/service/atomCarrier/del', data, loadingOptions)
export const delalarmObject = (data, loadingOptions) => httpRequest.httpdelete('/service/alarmObject/del', data, loadingOptions)
export const alarmRecorddl = (data, loadingOptions) => httpRequest.httpdelete('/service/alarmRecord/dl', data, loadingOptions)
export const delCertificate = (data, loadingOptions) => httpRequest.httpdelete('/service/userCertificate/del', data, loadingOptions)
export const delScene = (data, param) => httpRequest.httpdelete('/service/scene/delScene', data, param)
export const delplan = (data, param) => httpRequest.httpdelete('/service/scene/del', data, param)
export const deleteexception = (data, param) => httpRequest.httpdelete('/service/atomCarrier/exception/delete', data, param)
export const deleteUnix = (data, param) => httpRequest.httpdelete('/service/carrierOperateRecord/delete', data, param)
//  删除mqtt
export const deletemqttServer = (data, param) => httpRequest.httpdelete('/service/mqttServer/delete', data, param)
//  删除一个范围接口
export const accessRangeDel = (data, param) => httpRequest.httpdelete('/service/accessRange/delete', data, param)
export const frameForwarddel = (data, param) => httpRequest.httpdelete(`/service/frameForward/del?ids=${data}`, param)
export const downhistorydel = (data, param) => httpRequest.httpdelete(`/service/downhistory/del?ids=${data}`, param)

// 通过载体ID更新报警分组中的报警开关
export const updateAlarmSwitchByCarrierId = (carrierIds, carrierId, alarmSwitch) => {
  const carrierParam = carrierIds ? 'carrierIds=' + carrierIds : 'carrierId=' + carrierId
  return httpRequest.httpPut(`/service/atomCarrier/updateAlarmSwitchByCarrierId?${carrierParam}&alarmSwitch=${alarmSwitch}`)
}

/**
 * @put请求
 * @param {*} data
 *
 */
// export const saupUser = (params = {}) => httpRequest.httpPut({ url: '/service/role/right', ...params })
export const saupUser = (data, loadingOptions) => httpRequest.httpPut('/service/role/right', data)
export const allotUsers = (data, loadingOptions) => httpRequest.httpPut('/service/role/user/auth', data)
export const frameForwardupdate = (data, param) => httpRequest.httpPut('/service/frameForward/update', data, param)

// 重置用户密码
export const resetpwd = (k, data, loadingOptions) => httpRequest.httpPut('/service/account/resetpwd?id=' + k)

// 暂停/恢复
export const statusoff = (id, status, data, loadingOptions) => httpRequest.httpPut(`/service/task/status?id=${id}&status=${status}`)

// export const statusoff = (params = {}) => httpRequest.httpGet({
//   url: `/service/task/status/${params.status}`, params: {
//     ...params
//   }
// })

export const updateInfo = (data, loadingOptions) => httpRequest.httpPut('/service/account/upt', data)

export const compileSensor = (data, loadingOptions) => httpRequest.httpPost('/service/sensor/upt', data)

// 根据ids批量确认传感器 -列表监测未配置
export const sureRecord = (data, loadingOptions) => httpRequest.httpPut('/service/sensor/sureRecord?ids=' + data.ids + '&scopeId=' + data.scopeId)

// 编辑显示屏
export const editscreen = (data, loadingOptions) => httpRequest.httpPut('/service/terminal/upt', data)

export const updatestatus = (data, loadingOptions) => httpRequest.httpPut('/service/terminal/update-alarm-status', data)

export const updateGateway = (data, loadingOptions) => httpRequest.httpPut('/service/gateway/upt', data)

export const oldPut = (data, loadingOptions) => httpRequest.httpPut('/service/userInfo/old', data)
export const newold = (data, loadingOptions) => httpRequest.httpPut('/service/userInfo/new', data)
export const process = (data, loadingOptions) => httpRequest.httpPut('/service/alarmRecord/process', data)
export const sortScene = (data, loadingOptions) => httpRequest.httpPut('/service/scene/sortScene', data)
export const updateSceneType = (data, loadingOptions) => httpRequest.httpPut('/service/scene/updateSceneType', data)
export const uptScene = (data, loadingOptions) => httpRequest.httpPut('/service/scene/uptScene', data)
export const saveDeviceMap = (data, loadingOptions) => httpRequest.httpPut('/service/atomCarrier/saveDeviceMap', data)
export const operate = (data, loadingOptions) => httpRequest.httpPut('/service/setting/operate', data)
export const uptinfo = (data, loadingOptions) => httpRequest.httpPut('/service/atomCarrier/upt', data)
export const alterTask = (data, loadingOptions) => httpRequest.httpPut('/service/task/upt', data)
export const userauth = (data, loadingOptions) => httpRequest.httpPut('/service/core/role|user|auth', data)
export const uptStatus = (data, loadingOptions) => httpRequest.httpPut('/service/atomCarrier/uptStatus', data, loadingOptions)
export const uptRole = (data, loadingOptions) => httpRequest.httpPut('/service/role/upt', data, loadingOptions)
export const uptme = (data, loadingOptions) => httpRequest.httpPut('/service/userInfo/upt/me', data, loadingOptions)
export const putgetDeviceMap = (data, loadingOptions) => httpRequest.httpPut('/service/scene/saveDeviceMap', data, loadingOptions)
export const posmerge = (data, param) => httpRequest.httpPut('/service/scene/pos/merge', data, param)

// 更改新密码
// export const newUserInfo = (data, loadingOptions) => httpRequest.httpPut('/service/userInfo/new', data)
export const userLogin = (data, param) => httpRequest.httpPost('/service/user/login', data, param)
// mqtt的编辑接口
export const mqttEdit = (data, param) => httpRequest.httpPut('/service/mqttServer/update', data, param)
export const frameForwardadd = (data, param) => httpRequest.httpPut('/service/frameForward/add', data, param)
// 分页范围编辑接口
export const accessRangeUpdate = (data, param) => httpRequest.httpPut('/service/accessRange/update?id=' + `${param}`, data, param)

// 2022-2-17

// 导入气体模板
export const gasImportGas = (data) => httpRequest.httpPost('/service/gas/import',data)
// 导入门磁模板
export const magnetismImportMagnetism = (data) => httpRequest.httpPost('/service/magnetism/import', data)

// 保存组织架构
export const saveScenePlane = (data) => httpRequest.httpPost('/service/home/scene/save/plane', data)

// 获取平面图未绑定的所有设备
export const getUnBindDevice = (params = {}) => httpRequest.httpGet({
  url:  `/service/home/scene/position/device/unBind`,
  params: {
    ...params
  }
})
// 保存平面图保存定位设备
export const saveScenePlaneDevice = (data) => httpRequest.httpPost('/service/scene/save/device/position', data)
// 获取平面图绑定定位设备
export const getScenePlaneDevice = (planId) => httpRequest.httpGet({
  url:  `/service/home/scene/position/device/bind/${planId}`,
})
// 获取平面图定位监测点
export const getScenePlaneCarrier = (planId) => httpRequest.httpGet({
  url:  `/service/home/scene/position/carrier/bind/${planId}`,
})
